<template>
  <closeable-filter-badge-container
    class="filter-menu-element px-3 hover:bg-primary-light hover:text-primary-focus"
    @remove="onRemove"
  >
    <list-filter-value :labels="channelLabels"
                       :options="channelOptions"
                       :hide-labels="channels.length > 1"
                       label-full="All channels"
                       label-empty="No channels selected"
                       :class="{ 'gap-2': channels.length }"
    >
      <template>
        <span v-if="channels.length > 1">Channels:</span>
        <channel-type-icons :selectedChannels="selectedChannels"
                            :has-tooltip="channels.length > 1"
        />
      </template>
    </list-filter-value>
  </closeable-filter-badge-container>
</template>

<script>
import CloseableFilterBadgeContainer from './CloseableFilterBadgeContainer.vue'
import ListFilterValue from '@/components/analytics/filter/ListFilterValue'
import { FILTER_ITEMS } from '@/utils/filter.constants'
import ChannelTypeIcons from '@/components/analytics/filter/ChannelTypeIcons.vue'
import ChannelsIcon from '@/assets/images/icons/ChannelsIcon'

export default {
  name: 'ChannelsFilterBadge',
  props: {
    channels: {
      type: Array,
      required: true
    },
    channelOptions: {
      type: Array,
      required: true
    }
  },

  components: {
    ChannelTypeIcons,
    CloseableFilterBadgeContainer,
    ListFilterValue,
    ChannelsIcon
  },

  computed: {
    channelLabels() {
      return this.channels === null ?
        this.channelOptions.map(({ name }) => name) :
        this.selectedChannels.map(({ name }) => name)
    },

    selectedChannels() {
      return this.channelOptions.filter(
        ({ id }) => this.channels.includes(id)
      )
    }
  },

  methods: {
    onRemove() {
      this.$emit('remove', { [FILTER_ITEMS.CHANNELS]: null })
    }
  }
}
</script>

